'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _glamorous = require('glamorous');
var _glamorous2 = _interopRequireDefault(_glamorous);
var _themes = require('@marmalade/themes');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var _componentThemes$head = _themes.componentThemes.header,
  headerStyle = _componentThemes$head.headerStyle,
  headerTheme = _componentThemes$head.headerTheme;
var seperatorStyles = function seperatorStyles(_ref) {
  var theme = _ref.theme;
  return {
    width: '1px',
    height: '28px',
    backgroundColor: headerTheme(theme)[headerStyle('colorSeperator')],
    marginLeft: theme.space_sm,
    marginRight: theme.space_sm,
    propsAreCssOverrides: true
  };
};
exports.default = _glamorous2.default.div(seperatorStyles);